"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Utils = require("../../Utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Simple = function Simple(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      renderBottom = _ref.renderBottom,
      renderTop = _ref.renderTop;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    height: "100%",
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, {
    maxWidth: "lg"
  }, renderTop, /*#__PURE__*/_react["default"].createElement(_Utils.Headline, null, title), subtitle && /*#__PURE__*/_react["default"].createElement(_Utils.Tagline, null, subtitle), renderBottom));
};

Simple.defaultProps = {
  subtitle: '',
  renderBottom: null,
  renderTop: null
};
Simple.propTypes = {
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  renderBottom: _propTypes["default"].node,
  renderTop: _propTypes["default"].node
};
var _default = Simple;
exports["default"] = _default;